export default __webpack_public_path__ + "c129167ff2f23ac6aa5adbcdef16d863.svg";